/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMoneybotHome} from '../api'

 export const useQueryGetMoneybotHome = createReactQueryHook('getMoneybotHome', getMoneybotHome)
